import script from "./HomeNew.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeNew.vue?vue&type=script&setup=true&lang=js"

import "./HomeNew.vue?vue&type=style&index=0&id=12ced237&lang=scss"

const __exports__ = script;

export default __exports__